(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rare-gear-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = root => {
    if (root.dataset.ready) return;
    const cards = [...root.querySelectorAll('[data-rare-card]')];
    const controls = root.querySelector('.rare-finder__controls');
    const priority = root.querySelector('[data-rare-priority]');
    const grid = root.querySelector('[data-rare-cards]');
    const status = root.querySelector('[data-rare-status]');
    if (!cards.length || !controls || !priority) return;
    root.dataset.ready = 'true';
    controls.hidden = false;
    const update = reset => {
      const activity = root.querySelector('input[type=radio]:checked')?.value;
      const matches = cards.filter(card => card.dataset.activity === activity);
      const availablePriorities = new Set(matches.map(card => card.dataset.priority));
      [...priority.options].forEach(option => {
        option.hidden = option.value !== 'all' && !availablePriorities.has(option.value);
        option.disabled = option.hidden;
      });
      if (reset || !availablePriorities.has(priority.value)) priority.value = 'all';
      let count = 0;
      cards.forEach(card => {
        card.hidden = card.dataset.activity !== activity || (priority.value !== 'all' && card.dataset.priority !== priority.value);
        if (!card.hidden) count++;
      });
      grid.dataset.visibleCount = String(count);
      grid.style.setProperty('--rare-columns', String(Math.max(1, Math.min(count, 3))));
      status.textContent = status.dataset.template.replace('[count]', String(count));
      priority.closest('.rare-finder__priority').hidden = availablePriorities.size < 2;
    };
    root.addEventListener('change', event => {
      if (event.target.matches('input[type=radio]')) update(true);
      else if (event.target === priority) update(false);
    });
    update(true);
  };
  document.querySelectorAll('[data-rare-finder]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rare-finder]').forEach(initialise));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-product-explorer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    if (root.dataset.ready || !('IntersectionObserver' in window)) return;
    const chapters = [...root.querySelectorAll('[data-explore-chapter]')];
    const frames = [...root.querySelectorAll('[data-explore-frame]')];
    const buttons = [...root.querySelectorAll('[data-explore-button]')];
    if (chapters.length !== frames.length || !frames.length) return;
    root.dataset.ready = 'true';
    root.querySelector('nav').hidden = false;
    const activate = value => {
      frames.forEach(frame => frame.classList.toggle('is-active', frame.dataset.exploreFrame === value));
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.exploreButton === value)));
      chapters.forEach(chapter => chapter.classList.toggle('is-active', chapter.dataset.exploreChapter === value));
    };
    let observer;
    const observe = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length) activate(visible[0].target.dataset.exploreChapter);
      }, {rootMargin: window.matchMedia('(max-width:749px)').matches ? '-48% 0px -8% 0px' : '-25% 0px -25% 0px', threshold:[0,.2,.5]});
      chapters.forEach(chapter => observer.observe(chapter));
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      activate(button.dataset.exploreButton);
      chapters[Number(button.dataset.exploreButton)].scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }));
    const buy = root.querySelector('[data-explore-buy]');
    const form = document.querySelector('form[action*="/cart/add"] button[type="submit"]')?.closest('form');
    const options = document.querySelector('.m-product-option');
    if (options) {
      if (!options.getAttribute('id')) options.setAttribute('id', 'RarePurchaseOptions');
      buy.setAttribute('href', '#' + options.getAttribute('id'));
    } else if (form?.getAttribute('id')) buy.setAttribute('href', '#' + form.getAttribute('id'));
    else buy.setAttribute('href', '#MainContent');
    observe();
    const resize = new ResizeObserver(() => observe());
    resize.observe(root);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {observer.disconnect();resize.disconnect();}
    });
  };
  document.querySelectorAll('[data-rare-explore]').forEach(setup);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-rare-explore]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();
})();
